import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import { StaffMember } from "../DTOs/responses/staff";
import PeopleCard from "./PeopleCard";

interface StaffSectionProps {
  members: StaffMember[];
  titleKey: string;
  roleKey: string;
  featured?: boolean;
}

export default function StaffSection({
  members,
  titleKey,
  roleKey,
  featured = false,
}: StaffSectionProps) {
  const { t } = useTranslation();

  const renderBody = () => {
    if (members.length === 0)
      return (
        <Typography sx={{ color: "#9A948A", fontStyle: "italic" }}>
          {t("peopleEmpty")}
        </Typography>
      );

    return (
      <Grid container spacing={3} justifyContent={featured ? "center" : "flex-start"}>
        {members.map((member) => (
          <Grid
            item
            xs={12}
            sm={featured ? 12 : 6}
            md={featured ? 8 : 4}
            lg={featured ? 7 : 3}
            key={member.staffId}
          >
            <PeopleCard
              member={member}
              role={t(roleKey)}
              activitiesLabel={t("peopleCurrentActivities")}
              featured={featured}
            />
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <Box sx={{ mb: { xs: 5, md: 7 } }}>
      <Typography
        component="h2"
        sx={{
          color: "#20242A",
          fontFamily: "Source Sans Pro SemiBold",
          fontSize: { xs: 22, md: 27 },
          lineHeight: 1.15,
          mb: { xs: 2, md: 3 },
          pb: 1,
          borderBottom: "2px solid #EFE8DC",
        }}
      >
        {t(titleKey)}
      </Typography>
      {renderBody()}
    </Box>
  );
}
